import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const current = faqItems[activeIndex];

  const goNext = () => {
    setActiveIndex((prev) => (prev + 1) % faqItems.length);
  };

  const goPrev = () => {
    setActiveIndex((prev) => (prev - 1 + faqItems.length) % faqItems.length);
  };

  return (
    <section id="safety" className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            ( Frequently Asked Questions )
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-12 relative">
          <div className="mb-6">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-foreground-950 text-background-50 rounded-full text-xs font-semibold font-label">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
              </span>
              Top Q&amp;A
            </span>
          </div>

          <blockquote className="mb-8">
            <p className="text-base md:text-lg text-foreground-800 font-body leading-relaxed">
              &ldquo;{current.answer}&rdquo;
            </p>
          </blockquote>

          <div className="mb-6">
            <h3 className="text-sm font-semibold text-foreground-950 font-label">
              {current.question}
            </h3>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-accent-700 font-heading font-bold text-sm">H</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900 font-label">Hipobuy Team</p>
                <p className="text-xs text-foreground-500 font-body">guide@hipobuyspread.skin</p>
              </div>
            </div>

            <div className="flex items-center gap-1">
              <button
                onClick={goPrev}
                className="w-10 h-10 rounded-lg border border-foreground-300 flex items-center justify-center text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="Previous question"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-s-line text-lg"></i>
                </span>
              </button>
              <button
                onClick={goNext}
                className="w-10 h-10 rounded-lg bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="Next question"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </span>
              </button>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-6 gap-2">
          {faqItems.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setActiveIndex(idx)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                idx === activeIndex
                  ? 'bg-primary-500 w-6'
                  : 'bg-background-300 hover:bg-background-400'
              }`}
              aria-label={`Go to question ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}